/*
 * all.ts
 * descript-web-v2
 *
 * Last modified by marcello on 5/26/20, 1:28 PM
 * Copyright © 2020 Descript, Inc. All rights reserved.
 */
function all(values) {
    for (const value of values) {
        if (value instanceof Promise) {
            return Promise.all(values);
        }
    }
    return values;
}

/*
 * map.ts
 * descript-web-v2
 *
 * Last modified by marcello on 5/26/20, 1:28 PM
 * Copyright © 2020 Descript, Inc. All rights reserved.
 */
const throwingErrorCallback = (e) => {
    throw e;
};
function then(value, onValue, onError = throwingErrorCallback) {
    if (value instanceof Promise) {
        return value.then(onValue).catch(onError);
    }
    try {
        return onValue(value, true);
    }
    catch (e) {
        return onError(e);
    }
}

/*
 * cache.ts
 * descript-web-v2
 *
 * Last modified by marcello on 5/26/20, 1:27 PM
 * Copyright © 2020 Descript, Inc. All rights reserved.
 */
function getOrAdd(cache, key, compute) {
    const existing = cache.get(key);
    if (existing) {
        return existing;
    }
    let resultOrPromise = compute(key);
    if (resultOrPromise instanceof Promise) {
        // Return a promise that resolves after the cache has been updated
        resultOrPromise = resultOrPromise.then((result) => {
            cache.set(key, result);
            return result;
        });
    }
    cache.set(key, resultOrPromise);
    return resultOrPromise;
}

export { all, getOrAdd, then };
//# sourceMappingURL=index.esm.js.map
